import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../images/logo.png'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { useState } from 'react'
import Users from '../data/Users.json'
import { login } from '../slice/userSlice';
// import axios from "axios";
import { useSelector } from 'react-redux'

import Footer from '../components/Footer.js'






export default function Login() {
    
    const colo = useSelector((state) => state.theme)
    
    
    // const [user, setUser] = useState();

    // useEffect(() => {
    //     // get request to the API endpoint
    //     axios
    //         .get('https://randomuser.me/api/?results=20')
    //         .then((result) => setUser(result.data.results))
    //         .catch((err) => console.log(err));
    // }, []);

    // console.log(user)
    

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form, setForm] = useState({});
    // const [formv, setFormv] = useState({});
    // const [USER, setUSER] = useState({});

    // console.log(Users)

    function submitHandler(e) {
        e.preventDefault();
        // setFormv(form)
        

        

        // Users.map((user) => {
        //     if (form.eamil == user.email && form.password == user.password) {
        //         setUSER(user)
        //         console.log(USER)
        //         dispatch(login(USER));


        //     }
        //     // else {
        //     //     console.log('false')
        //     // }

        // })

        // navigate('/', { replace: true });

        for (let index = 0; index < Users.length; index++) {

            // setUSER(Users[index])
            if (form.eamil === Users[index].email && form.password === Users[index].password) {
                // console.log(USER)
                dispatch(login(Users[index]));
                navigate('/home', { replace: true });
                break
            }
            else {
                setWarnning(false)
            }
        }
        // for (let index = 0; index < user.length; index++) {

        //     // setUSER(Users[index])
        //     if (form.eamil === user[index].email && form.password === user[index].login.password) {
        //         // console.log(USER)
        //         dispatch(login(user[index]));
        //         navigate('/home', { replace: true });
        //         break
        //     }
        //     else {
        //         console.log('false')
        //     }
        // }


    }



    function onChangeHandler(event) {
        const name = event.target.name;
        const value = event.target.value.toLowerCase();

        setForm((values) => ({ ...values, [name]: value }));

        
    }

    const [warnning, setWarnning] = useState(true)




    return (
        <>
            <div className={`${colo.theme} bg-dwam h-full min-h-screen flex items-center justify-center md:p-20 py-[85px] px-7 `}>
                <div className="max-w-md  w-full h-full space-y-8 sm:outline  sm:outline-chwaram sm:rounded-md shadow-2xl p-2 ">
                    <div>
                        <Link to='/home' >
                            <img className="block mx-auto h-16 w-16" src={Logo} alt="logo" />
                        </Link>
                        <h2 className="mt-6 text-center text-3xl font-extrabold text-yakam drop-shadow-md dro">چوونەژوورەوە</h2>
                        
                    </div>
                    <form className="mt-8 space-y-6" onSubmit={submitHandler}>

                        <div className="rounded-md -space-y-px">

                            {warnning === true ?
                                (

                                    <div className="mb-3">
                                        <label for="email" className="block mb-1 text-md font-medium text-yakam">هەژماری ئەلیکترۆنی</label>
                                        <input
                                            className=" border-2 lowercase border-dwam text-chwaram text-sm rounded-lg focus:ring-yakam focus:border-yakam block w-full p-2.5 bg-yakam placeholder-dwam"
                                            type="email"
                                            name="eamil"
                                            id="eamil"
                                            value={form.eamil || ''}
                                            onChange={onChangeHandler}
                                        />
                                    </div>
                                )
                                :
                                (
                                    <div className="mb-3">
                                        <label for="email" className="block mb-1 text-md font-medium text-yakam">ئیمەڵ</label>
                                        <input
                                            className=" border-[3px]  border-red-700 text-chwaram text-sm rounded-lg focus:ring-yakam focus:border-yakam block w-full p-2.5 bg-yakam placeholder-dwam"
                                            type="email"
                                            name="eamil"
                                            id="eamil"
                                            value={form.eamil || ''}
                                            onChange={onChangeHandler}
                                        />
                                        <p className='text-xs drop-shadow-lg text-red-800 p-2'>وشەی نهێنی یان ئیمەیڵ هەڵەیە</p>
                                    </div>
                                )
                            }
                            {warnning === true ?
                                (

                                    <div className="mb-3">
                                        <label for="password" className="block mb-1 text-md font-medium text-yakam">وەشەی نهێنی</label>
                                        <input type="password" id="password" name='password' className=" border-2 border-dwam text-chwaram text-sm rounded-lg focus:ring-yakam focus:border-yakam block w-full p-2.5 bg-yakam  placeholder-dwam   " required
                                            value={form.password || ''}
                                            onChange={onChangeHandler}
                                        />
                                    </div>
                                )
                                :
                                (
                                    <div className="mb-3">
                                        <label for="password" className="block mb-1 text-md font-medium text-yakam">وەشەی نهێنی</label>
                                        <input type="password" id="password" name='password' className=" border-[3px]  border-red-700 text-chwaram text-sm rounded-lg focus:ring-yakam focus:border-yakam block w-full p-2.5 bg-yakam  placeholder-dwam   " required
                                            value={form.password || ''}
                                            onChange={onChangeHandler}
                                        />
                                        <p className='text-xs drop-shadow-lg text-red-800 p-2'>وشەی نهێنی یان ئیمەیڵ هەڵەیە</p>
                                    </div>
                                )
                            }

                        </div>
                        <div>
                            <button type='submit' className="shadow-sm shadow-penjam relative inline-flex items-center justify-center p-0.5 mb-2 mr-2 w-full overflow-hidden text-sm font-medium text-chwaram rounded-lg group bg-gradient-to-br from-penjam to-chwaram group-hover:from-penjam group-hover:to-chwaram hover:text-black  focus:ring-4 focus:outline-none focus:ring-green-200 ">
                                <span className="shadow-sm shadow-penjam relative w-full px-5 py-2.5 transition-all ease-in duration-75 bg-yakam  rounded-md group-hover:bg-opacity-0">
                                    چوونەژوورەوە
                                </span>
                            </button>
                        </div>
                    </form>
                    <div className="flex items-end  justify-end ">
                        <div className="text-sm">
                            <Link to="/register" className=" text-[18px] font-bold text-right text-chwaram hover:text-yakam">هەژمارت نییە؟ هەژمار دروستبکە</Link>
                        </div>
                    </div>

                </div>


            </div>

            <Footer />
        </>
    )
}
